/** Query params for GET /dashboard — mutually exclusive shapes per filter mode. */
export type DashboardGetParams =
  | { date: string }
  | { date_from: string; date_to: string }
  | { year: number }

export function toYmd(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/** Stable key so parent state can dedupe identical dashboard queries. */
export function serializeDashboardParams(p: DashboardGetParams): string {
  if ('date' in p) return `date:${p.date}`
  if ('year' in p) return `year:${p.year}`
  return `range:${p.date_from}:${p.date_to}`
}
